import axios from '@/libs/api.request'
// 文书修改顺序修改为自由辅导
export const setProjectEssayOrder = data => {
  return axios.request({
    url: '/project/modify/essay/order',
    data,
    method: 'POST'
  })
}
// 查询非再来人辅导的项目
export const getProjectUnZlrList = data => {
  return axios.request({
    url: '/project/un/zlr/project/list',
    data,
    method: 'POST'
  })
}
// 查询单个项目的详情
export const getProjectBasicDetail = data => {
  return axios.request({
    url: '/project/basic/detail',
    data,
    method: 'POST'
  })
}
// 添加面试信息
export const addProjectInterview = data => {
  return axios.request({
    url: '/project/interview/info/save',
    data,
    method: 'POST'
  })
}
// 获取面试信息
export const getProjectInterviewDetail = data => {
  return axios.request({
    url: '/project/interview/detail',
    data,
    method: 'POST'
  })
}
// 保存面试经历
export const subProjectInterviewExp = data => {
  return axios.request({
    url: '/project/interview/exp/save',
    data,
    method: 'POST'
  })
}
// 获取面试经历
export const getProjectInterviewExp = data => {
  return axios.request({
    url: '/project/interview/exp/info',
    data,
    method: 'POST'
  })
}
// 保存申请结果
export const subProjectResult = data => {
  return axios.request({
    url: '/project/result/modify',
    data,
    method: 'POST'
  })
}
// 获取申请结果
export const getProjectResult = data => {
  return axios.request({
    url: '/project/result/detail',
    data,
    method: 'POST'
  })
}
